export const MAX_EVENT_DESCRIPTION_LENGTH = 1600;
export const MAX_ADDITIONAL_INFO_LENGTH = 500;

export const bilingualTypes = {
  ENGLISH: 'english',
  SPANISH: 'spanish',
  BILINGUAL: 'bilingual',
  OTHER: 'other'
};

export const bilingualTypesEnum = [
  bilingualTypes.ENGLISH,
  bilingualTypes.SPANISH,
  bilingualTypes.BILINGUAL,
  bilingualTypes.OTHER
] as const;

export const locationTypes = {
  CHURCH: 'church',
  NON_PROFIT: 'non-profit',
  SCHOOL: 'school',
  BUSINESS: 'business',
  PUBLIC_PARK: 'public park',
  COMMUNITY_CENTER: 'community center',
  OTHER: 'other'
};

export const locationTypesEnum = [
  locationTypes.CHURCH,
  locationTypes.NON_PROFIT,
  locationTypes.SCHOOL,
  locationTypes.BUSINESS,
  locationTypes.PUBLIC_PARK,
  locationTypes.COMMUNITY_CENTER,
  locationTypes.OTHER
] as const;

export const typesOfOutreachActivity = {
  BEAUTIFICATION: 'beautification',
  FOOD_DISTRIBUTION: 'food distribution',
  GIFTS_IN_KIND_DISTRIBUTION: 'gifts-in-kind distribution',
  NEIGHBORHOOD_CANVASSING: 'neighborhood canvassing',
  HEALTH_CLINIC: 'health clinic',
  SPORTS_CAMP: 'sports camp',
  FESTIVAL_BLOCK_PARTY: 'festival / block party',
  NON_PROFIT_PARTNERSHIP: 'non-profit partnership',
  OTHER: 'other'
};

export const typesOfOutreachActivityEnum = [
  typesOfOutreachActivity.BEAUTIFICATION,
  typesOfOutreachActivity.FOOD_DISTRIBUTION,
  typesOfOutreachActivity.GIFTS_IN_KIND_DISTRIBUTION,
  typesOfOutreachActivity.NEIGHBORHOOD_CANVASSING,
  typesOfOutreachActivity.HEALTH_CLINIC,
  typesOfOutreachActivity.SPORTS_CAMP,
  typesOfOutreachActivity.FESTIVAL_BLOCK_PARTY,
  typesOfOutreachActivity.NON_PROFIT_PARTNERSHIP,
  typesOfOutreachActivity.OTHER
] as const;

export const preferredSkills = {
  GENERAL_VOLUNTEER: 'general volunteer',
  HANDYMAN: 'handyman',
  PAINTING: 'painting',
  ADMINISTRATION: 'administration',
  HOSPITALITY: 'hospitality',
  LANDSCAPING: 'landscaping',
  BILINGUAL_SPEAKERS: 'bilingual speakers',
  OTHER: 'other'
};

export const preferredSkillsEnum = [
  preferredSkills.GENERAL_VOLUNTEER,
  preferredSkills.HANDYMAN,
  preferredSkills.PAINTING,
  preferredSkills.ADMINISTRATION,
  preferredSkills.HOSPITALITY,
  preferredSkills.LANDSCAPING,
  preferredSkills.BILINGUAL_SPEAKERS,
  preferredSkills.OTHER
] as const;

export const causeTypes = {
  ABUSE_AND_HUMAN_TRAFFICKING: 'abuse & human trafficking',
  CHILDREN_AND_YOUTH: 'children & youth',
  COMMUNITY_DEVELOPMENT: 'community development',
  DISASTER_RELIEF: 'disaster relief',
  EDUCATIONAL_SUPPORT: 'educational support',
  ELDERLY_CARE: 'elderly care',
  FAMILIES_IN_CRISIS: 'families in crisis',
  HEALTH_AND_MEDICINE: 'health & medicine',
  HOUSING_AND_HOMELESSNESS: 'housing & homelessness',
  HUNGER_FOOD_SECURITY: 'hunger, food security',
  IMMIGRANTS_OR_REFUGEES: 'immigrants or refugees',
  INCARCERATION_AND_REENTRY_SUPPORT: 'incarceration and re-entry support',
  JOB_AND_WORKPLACE: 'job & workplace',
  MENTAL_HEALTH: 'mental health',
  NEURODIVERSITY_AND_DEVELOPMENTAL_DISABILITIES:
    'neurodiversity & developmental disabilities',
  PHYSICAL_DISABILITIES: 'physical disabilities',
  POVERTY: 'poverty',
  SINGLE_MOMS: 'single moms',
  SPORTS_AND_RECREATION: 'sports & recreation',
  VETERANS: 'veterans',
  VICTIM_SUPPORT: 'victim support',
  OTHER: 'other'
};

export const causeTypesEnum = [
  causeTypes.ABUSE_AND_HUMAN_TRAFFICKING,
  causeTypes.CHILDREN_AND_YOUTH,
  causeTypes.COMMUNITY_DEVELOPMENT,
  causeTypes.DISASTER_RELIEF,
  causeTypes.EDUCATIONAL_SUPPORT,
  causeTypes.ELDERLY_CARE,
  causeTypes.FAMILIES_IN_CRISIS,
  causeTypes.HEALTH_AND_MEDICINE,
  causeTypes.HOUSING_AND_HOMELESSNESS,
  causeTypes.HUNGER_FOOD_SECURITY,
  causeTypes.IMMIGRANTS_OR_REFUGEES,
  causeTypes.INCARCERATION_AND_REENTRY_SUPPORT,
  causeTypes.JOB_AND_WORKPLACE,
  causeTypes.MENTAL_HEALTH,
  causeTypes.NEURODIVERSITY_AND_DEVELOPMENTAL_DISABILITIES,
  causeTypes.PHYSICAL_DISABILITIES,
  causeTypes.POVERTY,
  causeTypes.SINGLE_MOMS,
  causeTypes.SPORTS_AND_RECREATION,
  causeTypes.VETERANS,
  causeTypes.VICTIM_SUPPORT,
  causeTypes.OTHER
] as const;
